import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import aws from "aws-sdk";
import axios from "axios";
import {
  Segment,
  Label,
  Button,
  Dimmer,
  Loader,
  List
} from "semantic-ui-react";

import uuid from "node-uuid";
import ImageComponent from "../../../common/Image/ImageComponent";
import * as EmployeeActions from "../employeeActions";
import * as constant from "../../../Global/Constant";
import { Common } from "../../../../utils";
class ProfileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      InLineLoading: false,
      btnShow: false
    };
    this.saveImage = this.saveImage.bind(this);
  }
  hidden = {
    display: "none"
  };
  saveImage() {
    let self = this;
    let file = this.props.File;
    let EmpId = this.props.personalInfo.Id;
    if (file === "" || file === null) {
      Common.showErrorMessage("Please select image");
      return;
    }
    self.setState({ InLineLoading: true });
    aws.config.update({
      accessKeyId: constant.GlobalKey.accessKeyId,
      secretAccessKey: constant.GlobalKey.secretAccessKey
    });
    let s3 = new aws.S3();
    let params = {
      Bucket: constant.GlobalKey.Bucket,
      Key: uuid() + file.name,
      ContentType: file.type,
      ACL: constant.GlobalKey.ACL
    };
    s3.getSignedUrl("putObject", params, function(err, signedUrl) {
      if (err) {
        self.setState({ InLineLoading: false });
        console.log(err);
        Common.showErrorMessage("Error Uploading Imaging To S3");
      } else {
        axios
          .put(signedUrl, file, { headers: { "Content-Type": file.type } })
          .then(function(result) {
            let Url =
              "https://" + params.Bucket + ".s3.amazonaws.com/" + params.Key;
            self.props.EmployeeActions
              .saveEmpImage(EmpId, Url)
              .then(response => {
                self.setState({ InLineLoading: false });
                if (response.success) {
                  self.props.EmployeeActions.profileImageSaveBtn(false);
                  Common.showSuccessMessage("Image Save Successfully");
                } else {
                  Common.showErrorMessage("Error Saving Imaging in Data Base");
                }
              })
              .catch(error => {
                self.setState({ InLineLoading: false });
                Common.showErrorMessage("Error Saving Imaging in Data Base");
              });
          })
          .catch(function(err) {
            self.setState({ InLineLoading: false });
            console.log(err);
            Common.showErrorMessage("Error Uploading Imaging To S3");
          });
      }
    });
  }

  render() {
    const { InfoData, onClickEdit } = this.props;
    return (
      <div>
        <Dimmer.Dimmable dimmed={this.state.InLineLoading}>
          <Dimmer active={this.state.InLineLoading} inverted={true}>
            <Loader>Loading</Loader>
          </Dimmer>
          <Segment className="ProfileDetailsCnt clear" basic>
            <Segment
              floated="left"
              basic
              className="profileHeaderTextCnt clear"
            >
              <div className="fl profileDetailsLeftInfo">
                <h1 className="LabelNoStyle EmployeeName">
                  <span>{InfoData.FirstName}</span>
                  {InfoData.LastName}
                </h1>
                <Label size="small" className="LabelNoStyle EmployeePosition">
                  {InfoData.Desigination}
                </Label>
                <Segment.Group className="BasicInfoCnt">
                  <Segment basic className="BasicInfoCnt-Inner">
                    <List className="userDataList">
                      <List.Item>
                        <label className="titleLabel">Department:</label>
                        <label>{InfoData.DepartmentName}</label>
                      </List.Item>

                      <List.Item>
                        <label className="titleLabel">Employee Number:</label>
                        <label>{InfoData.Id}</label>
                      </List.Item>

                      <List.Item>
                        <label className="titleLabel">CNIC:</label>
                        <label>{InfoData.CNIC}</label>
                      </List.Item>

                      <List.Item className="clear">
                        <ImageComponent />
                        <Button
                          style={
                            this.props.ProfileImageSaveBtn ? {} : this.hidden
                          }
                          content="Save"
                          onClick={this.saveImage}
                          primary
                          size="small"
                        />
                      </List.Item>
                      <List.Item>
                        <label className="empPh">{InfoData.MobileNo}</label>
                      </List.Item>

                      <List.Item>
                        <label className="empEmail">{InfoData.Email}</label>
                      </List.Item>
                      <List.Item>
                        <label className="empSkype">N/A</label>
                      </List.Item>
                    </List>
                  </Segment>
                </Segment.Group>
              </div>
            </Segment>

            <Button
              icon="edit"
              onClick={onClickEdit}
              circular
              className="EmployeeEditIcon"
            />
          </Segment>
        </Dimmer.Dimmable>
      </div>
    );
  }
}
const mapStateToProps = ({ employeeReducer }) => {
  const {
    File,
    personalInfo,
    InLineLoading,
    ProfileImageSaveBtn
  } = employeeReducer;
  return {
    File,
    personalInfo,
    InLineLoading,
    ProfileImageSaveBtn
  };
};

const mapDispatchToProps = dispatch => {
  return {
    EmployeeActions: bindActionCreators(EmployeeActions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
